import { Injectable } from '@angular/core';
import { PDFDocument, StandardFonts, rgb } from 'pdf-lib'
import { ballotMarkingData } from '../ballot/backend-types'

@Injectable({
  providedIn: 'root'
})
export class BallotMarkingService {

  constructor() { }

  async ballotToPdf(selectedChoices: ballotMarkingData[], blankBallot: Blob): Promise<Blob> {
    const existingPdfBytes = await blankBallot.arrayBuffer()
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);

    selectedChoices.forEach((choiceSelected) => {
      if (choiceSelected && choiceSelected.ballotMarkingMetadata?.page && choiceSelected.ballotMarkingMetadata?.x && choiceSelected.ballotMarkingMetadata?.y) {
        const choicePage = Number(choiceSelected.ballotMarkingMetadata?.page);
        const page = pdfDoc.getPage(choicePage - 1);
        const pageHeight = page.getHeight();
        const choiceX = Number(choiceSelected.ballotMarkingMetadata?.x);
        const choiceY = Number(choiceSelected.ballotMarkingMetadata?.y);
        const topToBottomY = pageHeight - choiceY;
        const color = rgb(0, 0, 0);
        const xScaledefaultValue = 4;
        const yScaledefaultValue = 2.5;
        const jsonxScale = Number(choiceSelected.ballotMarkingMetadata?.width);
        const jsonyScale = Number(choiceSelected.ballotMarkingMetadata?.height);
        const widthEllipse = (isNaN(jsonxScale) || (jsonxScale <= 0)) ?  xScaledefaultValue : jsonxScale;
        const heightEllipse = (isNaN(jsonyScale) || (jsonyScale <= 0)) ?  yScaledefaultValue : jsonyScale;

        if (choiceSelected.ballotMarkingMetadata?.shape === "ellipse") {
          page.drawEllipse({
            x: choiceX,
            y: topToBottomY,
            xScale: widthEllipse,
            yScale: heightEllipse,
            borderWidth: 1,
            borderColor: rgb(0, 0, 0),
            color: color,
          });
        }

        if (choiceSelected.ballotMarkingMetadata?.shape === "oval") {
          const svgPath = `M 0.5,-3 L 1.5,-3 C 5.5,-3 5.5,3 1.5,3 L -1,3 C -5.5,3 -5.5,-3 -1.5,-3 L -0.5,-3 Z`;

          page.drawSvgPath(svgPath, {
            x: choiceX,
            y: topToBottomY,
            borderColor: rgb(0, 0, 0),
            borderWidth: .75,
            borderOpacity: 1,
            scale:1.3,
            color: rgb(0, 0, 0)
          })
        }
        

        if (choiceSelected.isWriteIn) {
          const writeInAdjustXdefaultValue = 65;
          const writeInAdjustYdefaultValue = 10;
          const writeInDefaultFontSize = 10;
          const jsonWriteInDefaultFontSize = Number(choiceSelected.ballotMarkingMetadata?.writeInFontSize ?? 0);
          const jsonValueX = Number(choiceSelected.ballotMarkingMetadata?.writeInAdjustX);
          const jsonValueY = Number(choiceSelected.ballotMarkingMetadata?.writeInAdjustY);
          const writeInFontSize = (isNaN(jsonWriteInDefaultFontSize) || (jsonWriteInDefaultFontSize <= 0)) ? writeInDefaultFontSize : jsonWriteInDefaultFontSize;
          const writeInAdjustX = isNaN(jsonValueX) ? writeInAdjustXdefaultValue : jsonValueX;
          const writeInAdjustY = isNaN(jsonValueY) ? writeInAdjustYdefaultValue : jsonValueY;
          page.drawText(choiceSelected.description ?? "", {
            x: choiceX + writeInAdjustX,
            y: topToBottomY - writeInAdjustY,
            size: writeInFontSize,
            color: rgb(0, 0, 0),
            font: helveticaFont,
          });
        }
      }
    });
    const pdfBytes = await pdfDoc.save();
    const ballotPdf = new Blob([pdfBytes], { type: 'application/pdf' });
    return ballotPdf
  }
}